import React from 'react'
import "./Page4.css";

export default function Page4() {
    return (
        <div className="page4">

            <div className="contentContact">
                <div className="allinform3" style={{lineHeight: "1.5rem"}}>
                    <span style={{fontSize: "1.3rem"}}>
                        I have created an app which can protect    all your passwords, secret chats etc.. using
                        Encryption technology. <span style={{color: "rgb(253, 0, 84)"}}> Now you will encrypt your own data. </span> 
                        Benefits of this App :-
                        <br/>
                        <br/>
                        <span style={{color: "rgb(0, 253, 177)",fontSize: "1.2rem"}}>
                            - Very easy UI to understand
                            <br/>
                            <span style={{color: "rgb(0, 194, 253)"}}>- Easy accessible (Webapp / PWA)</span>
                            <br/>
                            - Your key can encrypt all data
                            <br/>
                            <span style={{color: "rgb(0, 194, 253)"}}>- Free (Open source) </span>
                        </span> 
                    </span>
                </div>

                <div className="forma2">
                    <a href="https://sagar712.github.io/scriptapp" target="_blank">
                        <button className="downloadbtn">Check WebApp</button>
                    </a>
                </div>
                
            </div>
        </div>
    )
}
